import { render, staticRenderFns } from "./sortList.vue?vue&type=template&id=ef6cc1c6&scoped=true"
import script from "./sortList.vue?vue&type=script&lang=ts"
export * from "./sortList.vue?vue&type=script&lang=ts"
import style0 from "./sortList.vue?vue&type=style&index=0&id=ef6cc1c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6cc1c6",
  null
  
)

export default component.exports